import { StorageState } from '../../../reducers';
import { createDataFetchSliceSelectors } from 'redux/utils/dataFetch';


export const clientAccountsSliceSelector = (state: StorageState) => state.client.accounts;

export const clientAccountsSelectors = createDataFetchSliceSelectors(clientAccountsSliceSelector);
export const clientAccountToDeleteSliceSelector = (state: StorageState) => state.client.accountToDelete;
